<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { CardTag } from '../CardTag';
	import { NewsMixpanelEvents } from '#lib/features/news/constants/mixpanel-events.js';
	import { getHeniTagLink } from '#lib/features/news/utils/getHeniTagLink/getHeniTagLink.js';
	import { HENI_TAG_LABEL } from '#lib/websites/news/constants/heni-tag.js';
	import { getSearchVariables } from '#lib/websites/news/pages/NewsHomePage/utils/getSearchVariables/getSearchVariables.js';
	import { isHeniTagActive } from '#lib/websites/news/pages/NewsHomePage/utils/isHeniTagActive/isHeniTagActive.js';
	import { page } from '$app/state';
	import { Txt } from '$global/components/Txt';
	import { track } from '$global/utils/track';

	let {
		dataCy,
		showNewVersion = false,
		onClick = undefined,
		forceShowGlobalNav = undefined,
		...rest
	}: Props = $props();

	interface Props {
		dataCy: string;
		class?: string;
		showNewVersion?: boolean;
		onClick?: (() => void) | undefined;
		forceShowGlobalNav?: boolean | undefined;
	}

	// The URL param is the fallback authority: on error pages (and any route
	// whose load doesn't provide showGlobalNav) page.data is empty, and
	// app-mode (global_nav=0) visitors must stay on navless links.
	let showGlobalNav = $derived(
		forceShowGlobalNav ??
			page.data.showGlobalNav ??
			page.url.searchParams.get('global_nav') !== '0'
	);

	let variables = $derived(getSearchVariables(page.url.searchParams));
	let active = $derived(isHeniTagActive({ variables }));
</script>

<CardTag
	{showNewVersion}
	onclick={() => {
		if (onClick) {
			onClick();
		}
		track(NewsMixpanelEvents.Search, { heni: true });
	}}
	href={getHeniTagLink(showGlobalNav)}
	class={twMerge(
		classNames('border-gray-900', {
			'bg-gray-900': active,
			'bg-transparent': !active,
			'h-[20px]': showNewVersion,
		}),
		rest.class
	)}
	{dataCy}
>
	<!-- `TagText` is not reused here: it sets an inline `style` colour derived as
	`${color}-600`, and the palette has no black at that shade, so the inline
	style would always beat a black class. -->
	<Txt
		variant="label2"
		class={twMerge(
			'px-2 text-[0.75rem] font-semibold',
			active ? 'text-white' : 'text-gray-900'
		)}
	>
		{HENI_TAG_LABEL}
	</Txt>
</CardTag>
